// Interactivity Style Plugin
import { createColorProperty, createSimpleProperty } from "./helpers.js";
export default {
    id: 'interactivity',
    label: 'Interactivity',
    icon: 'MousePointer',
    properties: {
        accentColor: {
            label: 'Accent Color',
            type: 'color',
            default: null,
            ...createColorProperty('accent')
        },
        appearance: {
            label: 'Appearance',
            type: 'select',
            options: ['none', 'auto'],
            default: 'auto',
            ...createSimpleProperty('appearance')
        },
        caretColor: {
            label: 'Caret Color',
            type: 'color',
            default: null,
            ...createColorProperty('caret')
        },
        colorScheme: {
            label: 'Color Scheme',
            type: 'select',
            options: ['light', 'dark', 'normal'],
            default: 'normal',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['light', 'dark', 'normal'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        cursor: {
            label: 'Cursor',
            type: 'select',
            options: ['auto', 'default', 'pointer', 'wait', 'text', 'move', 'help', 'not-allowed', 'none', 'context-menu', 'progress', 'cell', 'crosshair', 'vertical-text', 'alias', 'copy', 'no-drop', 'grab', 'grabbing', 'all-scroll', 'col-resize', 'row-resize', 'n-resize', 'e-resize', 's-resize', 'w-resize', 'ne-resize', 'nw-resize', 'se-resize', 'sw-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'zoom-in', 'zoom-out'],
            default: 'auto',
            ...createSimpleProperty('cursor')
        },
        fieldSizing: {
            label: 'Field Sizing',
            type: 'select',
            options: ['content', 'fixed'],
            default: 'fixed',
            ...createSimpleProperty('field-sizing')
        },
        pointerEvents: {
            label: 'Pointer Events',
            type: 'select',
            options: ['none', 'auto'],
            default: 'auto',
            ...createSimpleProperty('pointer-events')
        },
        resize: {
            label: 'Resize',
            type: 'select',
            options: ['resize', 'resize-none', 'resize-y', 'resize-x'],
            default: 'resize-none',
            toClass: (value) => value || null,
            fromClass: (className) => {
                if (['resize', 'resize-none', 'resize-y', 'resize-x'].includes(className)) {
                    return className;
                }
                return null;
            }
        },
        scrollBehavior: {
            label: 'Scroll Behavior',
            type: 'select',
            options: ['auto', 'smooth'],
            default: 'auto',
            toClass: (value) => value ? `scroll-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^scroll-(auto|smooth)$/);
                return match ? match[1] : null;
            }
        },
        scrollMargin: {
            label: 'Scroll Margin',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8'],
            default: '0',
            ...createSimpleProperty('scroll-m')
        },
        scrollPadding: {
            label: 'Scroll Padding',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8'],
            default: '0',
            ...createSimpleProperty('scroll-p')
        },
        scrollSnapAlign: {
            label: 'Snap Align',
            type: 'select',
            options: ['start', 'end', 'center', 'align-none'],
            default: 'start',
            ...createSimpleProperty('snap')
        },
        scrollSnapStop: {
            label: 'Snap Stop',
            type: 'select',
            options: ['normal', 'always'],
            default: 'normal',
            ...createSimpleProperty('snap')
        },
        scrollSnapType: {
            label: 'Snap Type',
            type: 'select',
            options: ['none', 'x', 'y', 'both', 'mandatory', 'proximity'],
            default: 'none',
            ...createSimpleProperty('snap')
        },
        touchAction: {
            label: 'Touch Action',
            type: 'select',
            options: ['auto', 'none', 'pan-x', 'pan-left', 'pan-right', 'pan-y', 'pan-up', 'pan-down', 'pinch-zoom', 'manipulation'],
            default: 'auto',
            ...createSimpleProperty('touch')
        },
        userSelect: {
            label: 'User Select',
            type: 'select',
            options: ['none', 'text', 'all', 'auto'],
            default: 'auto',
            ...createSimpleProperty('select')
        },
        willChange: {
            label: 'Will Change',
            type: 'select',
            options: ['auto', 'scroll', 'contents', 'transform'],
            default: 'auto',
            ...createSimpleProperty('will-change')
        }
    }
};
